module.exports = __webpack_public_path__ + "static/img/logo.f8362d65.svg";